declare const KTComponents: any;
declare const KTMenu: any;
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { StorageService } from '../../guards/StorageService';
import { PermissionService } from '../../api-services/Permission/permission.service';
import { AuthService } from '../../api-services/AdminHRService/Login/auth.service';

@Component({
  selector: 'app-hr-sidebar',
  standalone: false,
  templateUrl: './hr-sidebar.component.html',
  styleUrl: './hr-sidebar.component.css',
})

export class HrSidebarComponent implements OnInit, AfterViewInit {
  sidebarMenu: any = {};
  EmployeeName: any;
  DesignationName: any;
  profileUrl: string = '';
  heading = '';
  subheading = '';

  constructor(
    private router: Router,
    public storageService: StorageService,
    private readonly permissionService: PermissionService,
    private readonly authService: AuthService
  ) { }


  ngOnInit(): void {
    this.permissionService.restore();
    this.sidebarMenu = this.permissionService.getSidebarStructure();
    this.EmployeeName = this.authService.getUser()?.employeeName;
    this.DesignationName = this.authService.getUser()?.designation;
    this.profileUrl = this.permissionService.getProfileUrl(this.router.url);
  }

  updatePageHeader(page: unknown): void {
    // The outlet can activate during view checking; update after that check finishes.
    const heading = page && typeof page === 'object' && 'heading' in page && typeof page.heading === 'string'
      ? page.heading : '';
    const subheading = page && typeof page === 'object' && 'subheading' in page && typeof page.subheading === 'string'
      ? page.subheading : '';
    queueMicrotask(() => {
      this.heading = heading;
      this.subheading = subheading;
    });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (typeof KTMenu !== 'undefined') {
        KTMenu.createInstances();
      }

      if (typeof KTComponents !== 'undefined') {
        KTComponents.init();
      }
    }, 100);
  }

  btnSignOut() {
    this.authService.logout();
    this.permissionService.clear();
    this.storageService.clearAll();
    this.router.navigateByUrl('/SignIn');
  }

}
